import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  reportViewer: {
    height: "100%",
  },
  loadingProgress: {
    width: "100%", 
    opacity: 0.5, 
    marginTop: "2rem",
  },
}));
